import { FormGroup, FormControl, FormArray } from '@angular/forms';
import { ContrastAllergyType, PregnancyStatus, StrokeQueryType } from '@app/api-module/control-centre-api-client';
import { DefaultDropdownValue } from './constants';
import { ClientSite } from '@app/models/clientsite';

export type ContrastAllergyDropdownOption = DropdownOption<ContrastAllergyType>;
export type PregnancyDropdownOption = DropdownOption<PregnancyStatus>;
type DropdownOption<EnumType> = { display: string; value: DropdownKey<EnumType>; backgroundColor?: DropdownBackgroundColor };

export type ContrastAllergyMappingKey = DropdownKey<ContrastAllergyType>;
export type PregnancyMappingKey = DropdownKey<PregnancyStatus>;
type DropdownKey<EnumType> = EnumType | 'default';

export type DropdownBackgroundColor = 'none' | 'success' | 'warning' | 'error';

type ImagingRequestFormKey = keyof ImagingRequestForm;
export type ImagingRequestFormArray = 'relevantPriors' | 'scanRegions';
export type ImagingRequestFormGroup = Exclude<ImagingRequestFormKey, ImagingRequestFormArray | 'radiologistNotes'>;
export type ImagingRequestFormControl =
    | keyof PatientForm
    | keyof RequestedByForm
    | keyof PatientMedicalHistoryForm
    | 'requestCallWithRadiologist'
    | 'radiologistNotes';

export const RequestRadiologistCallToggleKeys = ['Yes', 'No', 'Required'];
export type RequestRadiologistCallToggleKey = typeof RequestRadiologistCallToggleKeys[number];

export interface ImagingRequestForm {
    patient: FormGroup<PatientForm>;
    requestedBy: FormGroup<RequestedByForm>;
    patientMedicalHistory: FormGroup<PatientMedicalHistoryForm>;
    relevantPriors: FormArray<FormGroup<EditablePrior>>;
    scanRegions: FormArray<FormGroup<ScanRegionForm>>;
    requestCallWithRadiologist: FormControl<boolean>;
}

export interface PatientForm {
    firstName: FormControl<string>;
    surname: FormControl<string>;
    dob: FormControl<Date>;
    location: FormControl<string>;
    hospitalNumber: FormControl<string>;
    site: FormControl<ClientSite>;
}

export interface RequestedByForm {
    clinicianName: FormControl<string>;
    clinicianPhoneNumber: FormControl<string>;
    authorityToRequestScans: FormControl<boolean>;
    requestedBy?: FormControl<string>;
}

export interface PatientMedicalHistoryForm {
    contrastAllergy: FormControl<ContrastAllergyType | DefaultDropdownValue>;
    pregnancy: FormControl<PregnancyStatus | DefaultDropdownValue>;
    differentialDiagnosis: FormControl<string>;
    clinicalHistory: FormControl<string>;
    egfr: FormControl<Egfr>;
    egfrResult?: FormControl<string>;
    stroke: FormControl<StrokeQueryType>;
    polyTrauma: FormControl<boolean>;
    paediatricConsult: FormControl<boolean>;
}

export interface EditablePrior {
    id: FormControl<number | null>;
    modality: FormControl<string>;
    studyDescription: FormControl<string>;
    studyDate: FormControl<Date>;
}

export interface ScanRegionForm {
    id: FormControl<number | null>;
    rowVersion: FormControl<string | null>;
    modality: FormControl<string>;
    bodyPart: FormControl<string>;
    phaseOfContrast: FormControl<string>;
}

export interface ScanRegionRequest {
    id?: number;
    rowVersion?: string;
    modality: string;
    bodyPart: string;
    phaseOfContrast: PhaseOfContrast;
}

export type Egfr = 'Unknown' | 'Known';

export const PhasesOfContrast = ['C-', 'C+', 'Unknown'];
export type PhaseOfContrast = typeof PhasesOfContrast[number];
